export default {
  notfound: '抱歉，您指定的頁面不存在。',
  forbidden: '抱歉，您沒有權限進入此頁面。'
};
